module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/Tulip-Fever.0fd1d1d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/Tulip-Fever.jpg
// module id = kkiM
// module chunks = 0